
namespace PaperTrail.NewsletterControl {

    @Serenity.Decorators.registerClass()
    export class ReadStoryDialog extends Serenity.EntityDialog<StoryRow, any> {
        protected getFormKey() { return StoryForm.formKey; }
        protected getIdProperty() { return StoryRow.idProperty; }
        protected getLocalTextPrefix() { return StoryRow.localTextPrefix; }
        protected getNameProperty() { return StoryRow.nameProperty; }
        protected getService() { return StoryService.baseUrl; }
        protected getDeletePermission() { return StoryRow.deletePermission; }
        protected getInsertPermission() { return StoryRow.insertPermission; }
        protected getUpdatePermission() { return StoryRow.updatePermission; }

        protected form = new StoryForm(this.idPrefix);

        loadEntity(entity: StoryRow) {
            super.loadEntity(entity);
            if (this.isNewOrDeleted()) {
                var user = Q.Authorization.userDefinition
                var userId = Administration.UserRow.getLookup().items
                    .filter(x => x.Username === user.Username)[0].UserId;
                this.form.UserId.value = userId.toString();
            }
        }

    }
}